export const TextField = () => import('./TextField.vue');
export const SelectField = () => import('./SelectField.vue');
export const Button = () => import('./Button.vue');
export const Hyperlink = () => import('./Hyperlink.vue');
export const ValidationError = () => import('./ValidationError.vue');
export const Alert = () => import('./Alert.vue');
export const Icon = () => import('./Icon/index.vue');
export const Modal = () => import('./Modal.vue');
export const Tabs = () => import(/* webpackChunkName: "Tabs" */ './Tabs/Tabs.vue');
export const Tab = () => import(/* webpackChunkName: "Tab" */ './Tabs/Tab.vue');
export const Card = () => import('./composite/Card/Card.vue');
export const FaqList = () => import(/* webpackChunkName: "FaqList" */ './composite/FaqList.vue');
export const Carousel = () => import(/* webpackChunkName: "Carousel" */ './Carousel.vue');
export const ProgressBar = () => import(/* webpackChunkName: "ProgressBar" */ './ProgressBar.vue');
export const Collapsible = () => import('./Collapsible.vue');
export const Accordion = () => import('./composite/Accordion.vue');
export const Banner = () => import('./Banner.vue');
